import { APP_BASE_HREF } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  PreloadAllModules,
  provideRouter,
  withInMemoryScrolling,
  withPreloading,
} from '@angular/router';
import { provideAuth } from '@auth/config';
import { LanguageService } from '@avenir-client-web/language';
import { provideCore } from '@core/core.config';
import Aura from '@primeng/themes/aura';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { getRoutes } from './app-routes';

function localeFactory(languageService: LanguageService): string {
  const locale = languageService.getLocale();

  languageService.setPreferredLocale(locale);

  return locale;
}

function getLanguageFromUrl(): string {
  return globalThis.location.pathname.split('/')[1];
}

function isLanguageSupported(locale: string, appConfig: any): boolean {
  return appConfig.supportedLanguages.includes(locale);
}

export function loadProviders(appConfig: any): ApplicationConfig {
  const locale = getLanguageFromUrl();
  const baseHref =
    locale && isLanguageSupported(locale, appConfig) ? `/${locale}/` : '/';

  return {
    providers: [
      {
        provide: LOCALE_ID,
        useFactory: localeFactory,
        deps: [LanguageService],
      },
      {
        provide: APP_BASE_HREF,
        useValue: baseHref,
      },
      MessageService,
      provideCore(),
      provideAuth(appConfig),
      importProvidersFrom(NgxPermissionsModule.forRoot()),
      importProvidersFrom(AngularSvgIconModule.forRoot()),
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimationsAsync(),
      providePrimeNG({
        theme: {
          preset: Aura,
          options: {
            darkModeSelector: false,
          },
        },
      }),
      provideRouter(
        getRoutes(appConfig),
        withPreloading(PreloadAllModules),
        withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
      ),
    ],
  };
}
